import styled, { css } from 'styled-components';

import {
  ThemeProps as Prop, Components,
} from '@powdr/constants';
import { themeUtil } from '@powdr/utils';

const CPNT = Components.CONTENT_BLOCK_CAROUSEL;

export const StyledContentBlockCarousel = styled.div`

  ${({ $isHorizontalScroll, $slidesToShow, $spaceBetween }) => $isHorizontalScroll && css`
    container-type: inline-size;

    .swiper-slide {
      width: calc((100cqw - ${($slidesToShow - 1) * $spaceBetween}px) / ${$slidesToShow}) !important;
      height: auto;
    }
  `}
`;

export const CarouselIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 30px 0;

  svg {
    fill: ${({ colorProfile }) => themeUtil(Prop.ICON, CPNT, colorProfile)};
    color: ${({ colorProfile }) => themeUtil(Prop.ICON, CPNT, colorProfile)};
  }
`;
